var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-multiselect',_vm._b({on:{"input":function($event){return _vm.$emit('input', $event)},"search-change":_vm.updateSearchTerm,"tag":function($event){return _vm.$emit('tag', $event)}},scopedSlots:_vm._u([{key:"tag",fn:function(props){return [_vm._t("tag",null,null,props)]}},{key:"option",fn:function(ref){
var option = ref.option;
return [_c('span',{directives:[{name:"bem",rawName:"v-bem:title",arg:"title"}]},[_vm._v("\n            "+_vm._s(option.name || option.title || option.label || option)+"\n        ")])]}}],null,true)},'vue-multiselect',{
        name: _vm.name,
        options: _vm.filteredOptions,
        trackBy: _vm.trackBy,
        showLabels: _vm.showLabels,
        value: _vm.value,
        allowEmpty: _vm.allowEmpty,
        internalSearch: _vm.internalSearch,
        placeholder: _vm.placeholder,
        disabled: _vm.disabled,
        multiple: _vm.multiple,
        closeOnSelect: _vm.closeOnSelect,
        taggable: _vm.taggable,
        tagPlaceholder: _vm.tagPlaceholder
    },false))}
var staticRenderFns = []

export { render, staticRenderFns }